// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/transfer_vision_project_ownership.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/transfer_vision_project_ownership.proto.
 */
export const file_vision_membership_v1_transfer_vision_project_ownership: GenFile = /*@__PURE__*/
  fileDesc("Cjx2aXNpb24vbWVtYmVyc2hpcC92MS90cmFuc2Zlcl92aXNpb25fcHJvamVjdF9vd25lcnNoaXAucHJvdG8SG3Byb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MSK+AQolVHJhbnNmZXJWaXNpb25Qcm9qZWN0T3duZXJzaGlwUmVxdWVzdBJZCgZwYXJhbXMYASABKAsySS5wcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEuVHJhbnNmZXJWaXNpb25Qcm9qZWN0T3duZXJzaGlwUmVxdWVzdC5QYXJhbXMaOgoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSHAoUbmV3X293bmVyX2FjY291bnRfaWQYAiABKAkijgEKJlRyYW5zZmVyVmlzaW9uUHJvamVjdE93bmVyc2hpcFJlc3BvbnNlEloKBnJlc3VsdBgBIAEoCzJKLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5UcmFuc2ZlclZpc2lvblByb2plY3RPd25lcnNoaXBSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.membership.v1.TransferVisionProjectOwnershipRequest
 */
export type TransferVisionProjectOwnershipRequest = Message<"protos.vision.membership.v1.TransferVisionProjectOwnershipRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.TransferVisionProjectOwnershipRequest.Params params = 1;
   */
  params?: TransferVisionProjectOwnershipRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.TransferVisionProjectOwnershipRequest.
 * Use `create(TransferVisionProjectOwnershipRequestSchema)` to create a new message.
 */
export const TransferVisionProjectOwnershipRequestSchema: GenMessage<TransferVisionProjectOwnershipRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_transfer_vision_project_ownership, 0);

/**
 * @generated from message protos.vision.membership.v1.TransferVisionProjectOwnershipRequest.Params
 */
export type TransferVisionProjectOwnershipRequest_Params = Message<"protos.vision.membership.v1.TransferVisionProjectOwnershipRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string new_owner_account_id = 2;
   */
  newOwnerAccountId: string;
};

/**
 * Describes the message protos.vision.membership.v1.TransferVisionProjectOwnershipRequest.Params.
 * Use `create(TransferVisionProjectOwnershipRequest_ParamsSchema)` to create a new message.
 */
export const TransferVisionProjectOwnershipRequest_ParamsSchema: GenMessage<TransferVisionProjectOwnershipRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_transfer_vision_project_ownership, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.TransferVisionProjectOwnershipResponse
 */
export type TransferVisionProjectOwnershipResponse = Message<"protos.vision.membership.v1.TransferVisionProjectOwnershipResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.TransferVisionProjectOwnershipResponse.Result result = 1;
   */
  result?: TransferVisionProjectOwnershipResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.TransferVisionProjectOwnershipResponse.
 * Use `create(TransferVisionProjectOwnershipResponseSchema)` to create a new message.
 */
export const TransferVisionProjectOwnershipResponseSchema: GenMessage<TransferVisionProjectOwnershipResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_transfer_vision_project_ownership, 1);

/**
 * @generated from message protos.vision.membership.v1.TransferVisionProjectOwnershipResponse.Result
 */
export type TransferVisionProjectOwnershipResponse_Result = Message<"protos.vision.membership.v1.TransferVisionProjectOwnershipResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.TransferVisionProjectOwnershipResponse.Result.
 * Use `create(TransferVisionProjectOwnershipResponse_ResultSchema)` to create a new message.
 */
export const TransferVisionProjectOwnershipResponse_ResultSchema: GenMessage<TransferVisionProjectOwnershipResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_transfer_vision_project_ownership, 1, 0);

